export default "__VITE_ASSET__XuTAbRPa__"